import { unreadNotes } from '@/domain';
import { useNoteThread } from '@/application/usecases/useKits';
import { useSession } from '@/application/usecases/useSession';
import { strings } from '@/shared/strings';
import { ChatIcon } from '@/ui/icons';
import styles from './LabNotesButton.module.css';

/**
 * The way into a case's Lab Notes, with how many messages are new since this
 * person last read them. Request of 4 October 2026, section 7.
 */
export function LabNotesButton({ kitId, onOpen }: { kitId: string; onOpen: () => void }) {
  const { data: session } = useSession();
  const thread = useNoteThread(kitId);
  const unread =
    thread.data === undefined || session === undefined || session === null
      ? 0
      : unreadNotes(thread.data.items, thread.data.lastReadAt, session.user.id);

  return (
    <button
      type="button"
      className={styles.button}
      aria-label={unread === 0 ? strings.labNotes.open : strings.labNotes.openWithUnread(unread)}
      onClick={onOpen}
    >
      <ChatIcon size={16} />
      <span>{strings.labNotes.open}</span>
      {unread > 0 && (
        <span className={styles.badge} aria-hidden="true">
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  );
}
